import { StructuredDataAuthorProps } from '@/shared/types/structured-data';
import { buildCloudFrontURL } from '@pietra/utils';

interface IProps {
  headline: string;
  image: string;
  author: StructuredDataAuthorProps[];
  datePublished: string;
  dateModified: string;
}

const StructuredDataNewsArticle = ({ headline, image, author, datePublished, dateModified }: IProps) => {
  const jsonData = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline,
    image: [
      buildCloudFrontURL(image, { width: 300, height: 300 }),
      buildCloudFrontURL(image, { width: 400, height: 300 }),
      buildCloudFrontURL(image, { width: 800, height: 450 }),
    ],
    datePublished,
    dateModified,
    author,
  };

  return (
    <script
      id={'news-article-jsonld'}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonData) }}
    />
  );
};

export default StructuredDataNewsArticle;
